module.exports = __webpack_public_path__ + "img/arrow_right_circle_w.3afb8df4.svg";